import React from 'react';
import HelpIcon from './HelpIcon';

const TextInput = ({
  label,
  name,
  register,
  errors,
  type = 'text',
  validation,
  align = 'left',
  placeholder,
  sx = {},
  showRequiredIndicator = false,
  helptext
}) => {
  let transform;
  switch(type) {
    case 'email':
      transform = 'lowercase';
      break;
    case 'postcode':
      transform = 'uppercase';
      break;
    default:
      transform='none';
  }

  return  (
  <div className="form-group" style={{ textAlign: align}}>
    <label htmlFor={name}>
      {label}
      {validation?.required && showRequiredIndicator && <span className="required-indicator">*</span>}
      <HelpIcon helptext={helptext} />
    </label>
    <input
      id={name}
      type={type}
      style={{...sx, textTransform: transform }}
      {...register(name, validation)}
      placeholder={`${["text","email","postcode", "number", "currency","company"].includes(type)?placeholder:'' }`}
    />
    {errors[name] && <p style={{ color: 'red' }}>{errors[name].message}</p>}
  </div>
)
};

export default TextInput;
